<template>
    <div class="container">
        <Login class="mb-4" :showHome="(isLinked == false || (hasAttachToMultipleDossiersCapability && isLinked == true)) ? 'search' : ''" />
        <hr/>
        <span v-if="isLoggedIn">
            <span v-if="!isCheckingMailLinked">
                <h5 class="mb-3" v-if="$store.state.linkedDossiers.length">
                    Dossiers liés
                </h5>
                <div class="linked-dossier-block" v-for="linkedDossier in $store.state.linkedDossiers" :key="linkedDossier.id">
                    <div class="col-12">
                        <span @click="openDossier(linkedDossier)" class="mb-2 black dossier-nom">
                            <i class="fas fa-folder"></i> {{ linkedDossier.nom + ' [' + linkedDossier.numero + ']' }}
                        </span>
                        <button class="btn btn-danger btn-sm unlink-btn" @click="unlinkMail(linkedDossier)" :disabled="isUnlinking">
                            <i class="fas fa-spin fa-spinner" v-if="isUnlinking"></i>
                            <span v-if="!isUnlinking"><i class="fas fa-times"></i></span>
                        </button>
                    </div>
                </div>
            </span>
            <hr v-if="hasAttachToMultipleDossiersCapability && $store.state.linkedDossiers.length"/>
            <h5 @click="openDossier($store.state.currentDossier)" class="text-center mb-3 black dossier-nom" v-if="$store.state.currentDossier && $router.currentRoute.name == 'arborescence'">
                <i class="fas fa-folder"></i> {{ $store.state.currentDossier.nom + ' [' + $store.state.currentDossier.numero + ']' }}
            </h5>
        </span>
    </div>
</template>

<script lang="ts">
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css';
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import CredentialsStore from '../store/credentials-store'
import { Cabinet, Dossier } from '../interfaces/interfaces'
import { mixins } from 'vue-class-component'
import LysiasApiMixin from '../mixins/LysiasApiMixin'
import SettingsMixin from '../mixins/SettingsMixin'
import Login from './Login.vue';

@Component({ store: CredentialsStore, components: { Login } })
export default class LinkingState extends mixins(LysiasApiMixin, SettingsMixin)
{
    private isUnlinking = false;
    private isLinked = false;
    private stateFetched = false;
    private isCheckingMailLinked = false;
    @Prop({ type: Boolean, default: false }) isLoggedIn!: boolean;


    async mounted()
    {
        await this.loadCabinets();
        await this.setCurrentCabinetAndAuthenticate();
        this.handleCredentialsMissing();

        Office.context.mailbox.removeHandlerAsync(Office.EventType.ItemChanged);
        Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, async (type:any) => {
            await this.onItemChanged(type);
        }, (result: Office.AsyncResult<void>) => {
            console.log('item ' + result);
        });

        try
        {
            console.log('created getState');
            await this.getState();
            this.stateFetched = true;
        }
        catch(e)
        {
            console.log(e);
        }
    }

    @Watch('credentialsMissing')
    onCredentialsMissing()
    {
        this.handleCredentialsMissing();
    }


    get credentialsMissing()
    {
        const state = this.$store.state;
        return state.cabinets.length == 0 || !state.currentCabinet || (state.currentCabinet && state.currentCabinet.credentials.username.trim().length == 0 && state.currentCabinet.credentials.password.trim().length == 0)

    }

    handleCredentialsMissing()
    {
        if(this.credentialsMissing)
        {
            //this.$router.push({ name: 'login', params: { showHome: 'true'} });
            //this.$store.dispatch('newLogin');
        }
    }

    async onItemChanged(type: Office.EventType)
    {
        console.log('itemChanged getState' + type);
        await this.getState();
        this.$store.dispatch('setErrorMessage', "");
        this.$store.commit('setSuccessMessage', "");
    }

    async getState()
    {
        try
        {
            this.$router.push({ name: 'loading' });

            if(!this.$store.state.currentCabinet)
            {
                this.$store.dispatch('setErrorMessage', 'Aucun cabinet selectionné');
                return;
            }

            const mail = Office.context.mailbox.item;

            this.isCheckingMailLinked = true;
            if(this.hasAttachToMultipleDossiersCapability)
            {
                this.isLinked = await this.isMailLinkedToMultipleDossier(mail!);
            }
            else
            {
                this.isLinked = await this.isMailLinkedToOneDossier(mail!);
            }

            this.isCheckingMailLinked = false;
            if(this.isLinked)
            {
                this.$router.push({ name: 'linked' });
            }
            else
            {
                console.log('wtf');
                this.$router.push({ name: 'search'});
            }
        }
        catch(e)
        {
            this.isCheckingMailLinked = false;
            console.log(e);
        }
    }

    @Watch('cabinets', { deep: true })
    onCabinetsChanged()
    {
        const mail = Office.context.mailbox.item;
    }

    get cabinets()
    {
        return this.$store.state.cabinets;
    }

    async unlinkMail(dossier: Dossier|null)
    {
        const mail = Office.context.mailbox.item;
        this.isUnlinking = true;

        try
        {
            if(this.hasAttachToMultipleDossiersCapability) {
                await this.removeMail(mail!, dossier);
                await this.isMailLinkedToMultipleDossier(mail!);
            }
            else
            {
                await this.removeMail(mail!, null);
                await this.isMailLinkedToOneDossier(mail!);
            }
        }
        catch(e)
        {
            this.$store.dispatch('setErrorMessage', "Impossible de délier le mail du dossier");
            console.log(e);
            return;
        }
        finally
        {
            this.isUnlinking = false;
        }

        this.$router.push({ name: 'linked'  });
    }

    openDossier(dossier: Dossier)
    {
        window.open(this.$store.getters.normalizedCabinetUrl + '/contentieux/' + dossier.id + '/save', '_blank');
    }

    async setCurrentCabinetAndAuthenticate()
    {
        if(this.$store.state.currentCabinet == null && this.$store.state.cabinets.length) {
            this.$store.commit('setCurrentCabinet', this.$store.state.cabinets[0]);

            if(this.$store.state.capabilities.length == 0 && this.$store.state.cabinets[0].credentials) {
                const username = this.$store.state.currentCabinet.credentials.username;
                const password = this.$store.state.currentCabinet.credentials.password;

                await this.login(username, password);
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .linked-dossier-block
    {
        background: #fff;
        margin-bottom: 5px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.07);
        border-radius: 8px;
        padding: 10px 1px;
    }

    .unlink-btn
    {
        font-size: 0.8em;
        float: right;
    }

    .dossier-nom:hover
    {
        cursor: pointer;
    }

    .dossier-nom .fa-folder
    {
        color: #E5007E;
    }
</style>
